import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { ClientPreview } from '~/components/ClientPreview/ClientPreview';
export const clientPreviewModalConfig = (param)=>{
    let { relationshipId } = param;
    return {
        biName: 'client_preview_modal',
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: (props)=>/*#__PURE__*/ _jsx(ClientPreview, _object_spread({
                type: "relationshipId",
                relationshipId: relationshipId
            }, props))
    };
};
